import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { renderElements, getStyles, addLoading, replacePanel } from '@netcall/card-renderer';
import { nanoid } from 'nanoid';
import { Card } from './card';
import { CardSubmitEvent } from './card-submit-event';
import { onMounted, onBeforeUnmount, PropType, ref, watch, toRef } from 'vue';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-app',
},
  __name: 'app',
  props: {
  readonly: {
    type: Boolean,
    required: true,
  },
  card: {
    type: Object as PropType<Card>,
    required: true,
  },
  colour: {
    type: String,
    required: true,
  },
  location: {
    type: String,
    required: true,
  },
},
  emits: ["submit"],
  setup(__props, { emit: __emit }) {



const props = __props;

const emit = __emit;

const id = `nc_${nanoid()}`;

const cardContainer = ref<HTMLElement | null>(null);
const submitTimeout = ref<ReturnType<typeof setTimeout>>();
const readonly = toRef(props.readonly);

watch(
  () => props.card,
  (card: Card) => renderCard(card),
);

watch(
  () => props.readonly,
  (value: boolean) => {
    readonly.value = value;
    renderCard(props.card);
  },
);

onMounted(() => {
  renderCard(props.card);
  document.addEventListener('fresco-panel-submit', cardSubmitHandler);
});

onBeforeUnmount(() => {
  document.removeEventListener('fresco-panel-submit', cardSubmitHandler);
});

function getDivStyles() {
  return getStyles(props.colour, id).innerHTML;
}

function renderCard(card: Card) {
  if (!cardContainer.value) {
    return;
  }
  clearSubmitTimeout();
  cardContainer.value.innerHTML = '';
  if (isCardComponentsValid(card)) {
    const cardJson = JSON.stringify(card.content.components);
    renderElements(card.id || '', cardJson, cardContainer.value, props.location, props.readonly);
  } else {
    renderError(card);
  }
}

function renderError(card: Card) {
  renderElements(card.id || '', '{}', cardContainer.value, props.location, props.readonly);
}

function isCardComponentsValid(card: Card) {
  return card.content && card.content.components && card.content.components.length > 0;
}

function cardSubmitHandler(e: Event) {
  if (isEventForCard(e)) {
    const customEvent = e as CustomEvent;
    const { panelId } = customEvent.detail;
    addLoadingSpinner(panelId);
    onSubmit(customEvent.detail);
  }
}

function isEventForCard(evt: any) {
  return evt.detail.panelId === props.card.id;
}

function onSubmit(e: CardSubmitEvent) {
  emit('submit', e);
}

function addLoadingSpinner(panelId: string) {
  addLoading(panelId);
  setSubmitTimeout(panelId);
}

function setSubmitTimeout(panelId: string) {
  submitTimeout.value = setTimeout(() => {
    replaceWithError(panelId);
  }, 30000);
}

function clearSubmitTimeout() {
  if (submitTimeout.value) {
    clearTimeout(submitTimeout.value);
  }
}

function replaceWithError(panelId: string) {
  // No method in render engine to display error state, but passing invalid json will result in that
  replacePanel(panelId, '!!!');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card-reset", id])
  }, [
    _createElementVNode("div", {
      innerHTML: getDivStyles()
    }, null, 8, _hoisted_1),
    _createElementVNode("div", {
      ref_key: "cardContainer",
      ref: cardContainer,
      class: "card-container"
    }, null, 512)
  ]))
}
}

})